module.exports = __webpack_public_path__ + "img/Group 100.6cc1339d.png";